/**
 * The Twitch embed color theme to use.
 */
export var TwitchEmbedTheme;
(function (TwitchEmbedTheme) {
    TwitchEmbedTheme["DARK"] = "dark";
    TwitchEmbedTheme["LIGHT"] = "light";
})(TwitchEmbedTheme || (TwitchEmbedTheme = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVHdpdGNoRW1iZWRUaGVtZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9saWIvZXZlcnl0aGluZy9Ud2l0Y2hFbWJlZFRoZW1lLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOztHQUVHO0FBQ0gsTUFBTSxDQUFOLElBQVksZ0JBR1g7QUFIRCxXQUFZLGdCQUFnQjtJQUMxQixpQ0FBYSxDQUFBO0lBQ2IsbUNBQWUsQ0FBQTtBQUNqQixDQUFDLEVBSFcsZ0JBQWdCLEtBQWhCLGdCQUFnQixRQUczQiJ9